var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7192 4.25C23.8192 4.7 22.9192 4.85 21.8692 5C22.9192 4.4 23.6692 3.5 23.9692 2.3C23.0692 2.9 22.0192 3.2 20.8192 3.5C19.9192 2.6 18.5692 2 17.2192 2C14.0692 2 11.6692 5 12.4192 8C8.36924 7.85 4.76924 5.9 2.21924 2.9C0.869238 5.15 1.61924 8 3.71924 9.5C2.96924 9.5 2.21924 9.2 1.46924 8.9C1.46924 11.15 3.11924 13.25 5.36924 13.85C4.61924 14 3.86924 14.15 3.11924 14C3.71924 15.95 5.51924 17.45 7.76924 17.45C5.96924 18.8 3.26924 19.55 0.719238 19.25C2.96924 20.6 5.51924 21.5 8.21924 21.5C17.3692 21.5 22.4692 13.85 22.1692 6.8C23.2192 6.2 24.1192 5.3 24.7192 4.25Z",
    fill: "#000033"
  })));
};
export default SvgTwitter;